import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import HistoryItemJob from '@/components/formats/ShokurekishoParts/HistoryItemJob.vue'
import HistoryItemJobCareer from '@/components/formats/ShokurekishoParts/HistoryItemJob_career.vue'
import HistoryItemJobSkillsheet from '@/components/formats/ShokurekishoParts/HistoryItemJob_skillsheet.vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoHistories } from '@/composables/format-edit/useShokurekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'

type JobHistoryVariant = 'job' | 'career' | 'skillsheet'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoJobHistoryCard',
  props: {
    currentCardId: null,
    basicData: null,
    lead: { default: '今までに在籍した会社の概要を入力しましょう。\n会社ごとに、業務の実績や参加プロジェクトの説明も追加できます。' },
    showOmonajiseki: { type: Boolean, default: true },
    variant: { default: 'job' },
    descriptionPlaceholder: { default: '会社名を入力' }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, basicData: BasicData, lead: string, showOmonajiseki: boolean, variant: JobHistoryVariant, descriptionPlaceholder: string };



const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useProvidedShokurekishoHistories()

const itemByVariant = {
  job: HistoryItemJob,
  career: HistoryItemJobCareer,
  skillsheet: HistoryItemJobSkillsheet
}

const resolvedItemComponent = computed(() => itemByVariant[props.variant])
const leadLines = computed(() => props.lead.split('\n'))

return { __sfc: true,props, descriptionMaxLength, formatData, activeHistoryItem, addJobHistory, deleteJobHistory, moveJobHistory, addProjectHistory, deleteHistoryDetail, moveJobHistoryDetail, activateHistoryItem, itemByVariant, resolvedItemComponent, leadLines }
}

})